import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import MainLayout from './layouts/LoginLayout';
import DashboardLayout from "./layouts/DashboardLayout";
import StudentsLayout from "./layouts/StudentsLayout";
import InvoicesLayout from "./layouts/InvoicesLayout";
import ExpensesLayout from "./layouts/ExpensesLayout";
import PaymentsLayout from "./layouts/PaymentsLayout";
import BalancesLayout from "./layouts/BalancesLayout";
import StudentInvoicesLayout from "./layouts/StudentInvoicesLayout";
import StudentDetailsLayout from "./layouts/DetailsLayout";
import ViewInvoice from "./pages/ViewInvoice";
import ViewExpense from "./pages/ViewExpense";
import ReceiptLayout from "./layouts/ReceiptLayout";
import JournalLayout from "./layouts/JournalLayout";
import AppLayout from "./layouts/AppLayout";
import PayrollLayout from "./layouts/PayrollLayout";
import TrialLayout from "./layouts/TrialLayout";
import TransportLayout from "./layouts/TransportLayout";

import AccountLayout from "./layouts/AccountLayout";
import SalariesLayout from "./layouts/SalaryLayout";
import VoteheadLayout from "./layouts/VoteheadLayout";

import PosLayout from "./layouts/PosLayout";

import BulkImportLayout from "./layouts/BulkImportLayout";
import PaymentBulkImportLayout from "./layouts/PaymentBulkImportLayout";

import PosMainLayout from "./layouts/PosMainLayout";
import ParentFeeLayout from "./layouts/ParentFeeLayout";
import AdminAutomationSettings from "./layouts/AutomationLayout";
import PettyCash from "./layouts/PettyCashLayout";
import Transfer from "./layouts/TransferLayout";
import FeeBalance from "./layouts/FeeBalanceLayout";



//Surveys
import DataCollection from "./layouts/SurveyClientLayout";
import DataCollectionDashboard from "./layouts/SurveyDashboardLayout";
import Exam from "./layouts/ExamLayout";
import Grade1to3 from "./layouts/Grade1to3";
import Grade4to6 from "./layouts/Grade4to6";


import Assets from "./layouts/Assets";


//Profile management
import Profile from "./layouts/ProfileLayout";

//Erp app management
import ERP from "./erp/App";

//Chart of accounts management
import COA from "./layouts/accounting/AccountingLayout";

//E-commerce
import NewEcommerce from "./ecommerce/NewEcommerce";


import StaffLayout from "./layouts/StaffLayout";
import DepartmentLayout from "./layouts/DepartmentLayout";
import DocumentsLayout from "./layouts/DocumentsLayout";
import LeaveLayout from "./layouts/LeaveLayout";
import LeaveTypesLayout from "./layouts/LeaveTypesLayout";
import ContractLayout from "./layouts/ContractLayout";

//E-commerce
import NewTestEcommerce from "./pages/TestEcommerce";
import FlashBar from "./pages/FlashBar";
import NavigationBar from "./pages/NavigationBar";
import MainPage from "./pages/CmsMain";
import PosLogin from "./components/PosLogin";
import Banner from "./pages/BannerAdmin";
import CategoryAdmin from "./pages/CategoryAdmin";
import AdminMain from "./pages/AdminMainCms";
import ProductAdmin from "./pages/ProductAdmin";
import HeroAdmin from "./pages/HeroAdmin";
import FooterAdmin from "./pages/FooterAdmin";
import CartAdmin from "./pages/CartAdmin";
import SearchAdmin from "./pages/SearchAdmin";
import ProductViewAdmin from "./pages/ProductView";
import ProductViewComponent from "./pages/ProductViewComponent";
import CheckoutEditComponent from "./pages/CheckoutAdmin";
import Checkout from "./pages/Checkout";
import CustomPage from "./pages/CustomPage";
import ShopPage from "./pages/ShopPageAdmin";
import Vlog from "./pages/RichTextEditorAdmin";
import Contact from "./pages/Contact";
import Orders from "./pages/Orders";
import Shop from "./pages/Shop";
import ChristmasAdmin from "./pages/ChristmasAdmin";
import Help from "./pages/Help";
import Terms from "./pages/Terms";
import Stores from "./pages/Stores";
import Testimonials from "./pages/TestimonialsAdmin";
import Faqs from "./pages/FaqAdmin";
import Authentication from "./pages/Authentication";
import Wishlist from "./pages/Wishlist";
import UserAccount from "./pages/UserAccount";
import CategoryNavAdmin from "./pages/CategoriesNavAdmin";
import SearchBar from "./pages/SearchBar";
import CtaAdmin from "./pages/CtaAdmin";
import ModalAdmin from "./pages/ModalAdmin";
import NewNav from "./pages/NewNav";
import BulkTable from "./pages/BulkTable";
import ImageViewer from "./pages/ImageViewer";
//Payroll Login Logic
import Passcode from "./pages/Passcode";
import CmsPasscode from "./pages/CmsPasscode";
import WaterLogin from "./pages/WaterLogin";
import PayrollDashboard from "./ecommerce/Payroll";
import Employees from "./ecommerce/Salaries";
import Benefits from "./ecommerce/Benefits";
import Transfers from "./layouts/FeeTransferLayout";
import Void from "./layouts/VoidLayout";
import Success from "./pages/Success";
import SoftwareTemplate from "./pages/SoftwareTemplate";
import EmployeeProfile from "./ecommerce/EmployeeProfile";
function App() {
  return (
    <Router> 
      <Routes>
        <Route path="/Cms" element={<CmsPasscode/>} />
         <Route path="/" element={<MainPage/>} />
         <Route path="/WaterLogin" element={<WaterLogin/>} />
       <Route path="/PayrollDashboard" element={<PayrollDashboard/>} />
        <Route path="/EmployeeProfile/:id" element={<EmployeeProfile/>} />
        <Route path="/employees" element={<Employees/>} />
        <Route path="/ImageViewer" element={<ImageViewer/>} />
        <Route path="/Benefits" element={<Benefits/>} />
         <Route path="/Transfer" element={<Transfers/>} />
          <Route path="/Payments" element={<Void/>} />

        <Route path="/site/SoftwareTemplate" element={<SoftwareTemplate/>} />
       <Route path="/NewTestEcommerce" element={<NewTestEcommerce/>} />
       <Route path="/DataCollection" element={<DataCollection/>} />
       <Route path="/MainPage_s" element={<MainPage/>} />
       <Route path="/home" element={<MainPage/>} />
       <Route path="/AdminMain" element={<AdminMain/>} />
       <Route path="/CategoriesEdit" element={<CategoryAdmin/>} />
        <Route path="/HeroEdit" element={<HeroAdmin/>} />
          <Route path="/CartEdit" element={<CartAdmin/>} />
           <Route path="/ProductViewEdit" element={<ProductViewAdmin/>} />
            <Route path="/products/:id" element={<ProductViewComponent/>} />
            <Route path="/CheckoutEditComponent" element={<CheckoutEditComponent/>} />
             <Route path="/Checkout" element={<Checkout/>} />
         <Route path="/FooterEdit" element={<FooterAdmin/>} />
          <Route path="/CategoryNavEdit" element={<CategoryNavAdmin/>} />
          <Route path="/SearchEdit" element={<SearchAdmin/>} />
       <Route path="/Authentication" element={<Authentication/>} />
         <Route path="/ChristmasAdmin" element={<ChristmasAdmin/>} />
         <Route path="/Banner" element={<Banner/>} />
         <Route path="/SearchBar" element={<SearchBar/>} />
        <Route path="/FlashBar" element={<FlashBar/>} />
        <Route path="/ModalAdmin" element={<ModalAdmin/>} />
        <Route path="/CtaAdmin" element={<CtaAdmin/>} />
          <Route path="/myAccount" element={<UserAccount/>} />
          <Route path="/myAccount/:tab/:product_id" element={<UserAccount/>} />
        <Route path="/ShopPage" element={<ShopPage/>} />
         <Route path="/Vlog" element={<Vlog/>} />
         <Route path="/Help" element={<Help/>} />
         <Route path="/Terms" element={<Terms/>} />
         <Route path="/Shop" element={<Shop/>} />
          <Route path="/TestimonialsEdit" element={<Testimonials/>} />
          <Route path="/FaqsEdit" element={<Faqs/>} />
          <Route path="/Stores" element={<Stores/>} />
          <Route path="/Wishlist" element={<Wishlist/>} />
         <Route path="/Shop/:_slug?" element={<Shop/>} />
          <Route path="/newnav" element={<NewNav/>} />
          <Route path="/Shop/:_slug/:_status" element={<Shop/>} />
         <Route path="/Orders" element={<Orders/>} />
         <Route path="/success" element={<Success/>} />
          <Route path="/Orders/:order_id" element={<Orders/>} />
          <Route path="/Contact" element={<Contact/>} />
          <Route path="/i/:page_index" element={<CustomPage/>} />
          
        <Route path="/ProductEdit" element={<ProductAdmin/>} />
       <Route path="/NavigationBar" element={<NavigationBar/>} />
       <Route path="/Grading/:idaupi" element={<Exam/>} />
        <Route path="/Grading" element={<Exam/>} />

         <Route path="/Assessment" element={<Grade1to3/>} />
         <Route path="/Profile" element={<Profile/>} />

         <Route path="/ERP" element={<ERP/>} />
         <Route path="/COA/:id" element={<COA />} />
         <Route path="/E-commerce" element={<NewEcommerce/>} />

          <Route path="/staff" element={<StaffLayout/>} />
           <Route path="/contract" element={<ContractLayout/>} />
           <Route path="/departments" element={<DepartmentLayout/>} />
           <Route path="/documents" element={<DocumentsLayout/>} />
           <Route path="/staffleave" element={<LeaveLayout/>} />
           <Route path="/LeaveTypes" element={<LeaveTypesLayout/>} />



       

        <Route path="/Grade4to6/:idaupi" element={<Grade4to6/>} />
        <Route path="/Grade4to6" element={<Grade4to6/>} />
         <Route path="/Assets_/:expense_id" element={<Assets/>} />
          <Route path="/Assets_" element={<Assets/>} />
         



        

       <Route path="/DataCollectionDashboard" element={<DataCollectionDashboard/>} />

  
    <Route path="/BulkTable" element={<BulkTable/>} />
     
    {/* <Route path="/" element={<MainLayout/>} />
         <Route path="/" element={<PosLogin/>} />*/}
        <Route path="/BulkImport" element={<BulkImportLayout/>} />
        <Route path="/PaymentBulkImport" element={<PaymentBulkImportLayout/>} />
        <Route path="/AdminAutomationSettings" element={<AdminAutomationSettings/>} />
         <Route path="/apps" element={<AppLayout/>} />
         <Route path="/ParentPortal" element={<ParentFeeLayout/>} />
          <Route path="/pos" element={<PosMainLayout/>} />
          <Route path="/petty-cash" element={<PettyCash/>} />
          <Route path="/e-commerce-and-pos" element={<PosLayout/>} />
           <Route path="/Voteheads/:mode" element={<VoteheadLayout/>} />
           <Route path="/salaries" element={<SalariesLayout/>} />
        <Route path="/dashboard" element={<DashboardLayout/>} />
         <Route path="/Transfer" element={<Transfer/>} />
         <Route path="/payroll" element={<PayrollLayout/>} />
        <Route path="/students" element={<StudentsLayout/>} />
         <Route path="/invoices" element={<InvoicesLayout/>} />
         <Route path="/expenses" element={<ExpensesLayout/>} />
           <Route path="/payments" element={<PaymentsLayout/>} />
            <Route path="/balances" element={<BalancesLayout/>} />
              <Route path="/FeeBalance" element={<FeeBalance/>} />
        <Route path="/students/:id/invoices" element={<StudentDetailsLayout />} />
         <Route path="/students/:id/details" element={<StudentDetailsLayout />} />
           <Route path="/students/:id/viewinvoice" element={<ViewInvoice />} />
            <Route path="viewexpense/:id" element={<ViewExpense />} />
            <Route path="/students/:id/viewreceipt" element={<ReceiptLayout />} />
<Route path="/journals" element={<JournalLayout />} />
<Route path="/trial-balance" element={<TrialLayout />} />
<Route path="/transport" element={<TransportLayout />} />
<Route path="/chart-of-accounts" element={<AccountLayout />} />
<Route path="/chart-of-accounts/:id" element={<AccountLayout />} />
      </Routes>
    </Router>
   
  );
}

export default App;
